import { SystemPage } from '@/components/system/system-page'
import { Button } from '@/components/ui/button'
import { RotateCw, ServerCrash } from 'lucide-react'

interface ServerErrorPageProps {
  onRetry?: () => void
  /** Optional incident ID for support reference (rendered as a badge). */
  incident?: string
}

export function ServerErrorPage({ onRetry, incident }: ServerErrorPageProps) {
  return (
    <SystemPage
      code="500"
      icon={ServerCrash}
      tone="danger"
      title="Внутрішня помилка сервера"
      hint="Сталась несподівана помилка. Дані не втрачені — журнал транзакцій зберігається в незмінному вигляді. Спробуйте ще раз або зверніться до підтримки."
      badge={incident ? `Інцидент: ${incident}` : undefined}
      primaryAction={
        onRetry && (
          <Button onClick={onRetry}>
            <RotateCw className="size-3.5" />
            Спробувати знову
          </Button>
        )
      }
    />
  )
}
